import React from "react"
import { Field } from "formik"
import PropTypes from "prop-types"

export const Check = ({
  formik,
  id,
  name,
  value,
  label,
  className,
  labelClassName,
  inputClassName,
  img,
  onClick,
  checked,
  onChange,
  disabled,
}) => {
  return (
    <>
      {formik ? (
        <div className={`form-check ${className}`} onClick={onClick}>
          <Field
            type="checkbox"
            id={id}
            name={name}
            className={`form-check-input ${inputClassName}`}
            checked={checked}
            value={value}
            onChange={onChange}
            disabled={disabled}
          />
          <div className="el-after" />
          <label className={`form-check-label ${labelClassName}`} htmlFor={id}>
            {label}
          </label>
        </div>
      ) : (
        <div className={`form-check ${className}`} onClick={onClick}>
          <input
            type="checkbox"
            id={id}
            name={name}
            className={`form-check-input ${inputClassName}`}
            checked={checked}
            value={""}
            onChange={onChange}
            disabled={disabled}
          />
          <div className="el-after" />
          <label className={`form-check-label ${labelClassName}`} htmlFor={id}>
            {label}
          </label>
        </div>
      )}
    </>
  )
}

Check.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.any,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  defaultValue: PropTypes.array,
}

Check.defaultProps = {
  id: "",
  className: "",
  labelClassName: "",
  inputClassName: "",
  defaultValue: [25, 30],
}
